module.exports = __webpack_public_path__ + "static/determined-expanded-4-5176deb7f53c172fb306429d3b8b4b53.png";